import { render } from "./interact.vue?vue&type=template&id=480f16b7&scoped=true"
import script from "./interact.vue?vue&type=script&lang=js"
export * from "./interact.vue?vue&type=script&lang=js"

import "./interact.vue?vue&type=style&index=0&id=480f16b7&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480f16b7"]])

export default __exports__